import { Text, Tooltip, Stack } from '@customerio/pluma-components/react';
import {
  getQualityIndicator,
  getInverseQualityIndicator,
  getQualityColor,
  getQualityMessage,
} from '../utils/quality-indicators';

type MetricName = 'deliveryRate' | 'bounceRate' | 'spamRate' | 'openRate' | 'clickRate';

interface MetricCellProps {
  percent: number;
  count: number;
  metricName: MetricName;
  isInverse?: boolean;
}

export function MetricCell({ percent, count, metricName, isInverse = false }: MetricCellProps) {
  const quality = isInverse
    ? getInverseQualityIndicator(metricName, percent)
    : getQualityIndicator(metricName, percent);
  const color = getQualityColor(quality);
  const precision = metricName === 'spamRate' ? 2 : 1;

  const message = getQualityMessage(metricName, quality, isInverse, precision);

  const formattedPercent = formatPercent(percent, precision);
  const formattedCount = formatNumber(count);

  const content = (
    <Stack cursor={message != null ? 'help' : undefined}>
      <Text color={color}>{formattedPercent}</Text>
      <Text color="subtle" size="xs">
        {formattedCount}
      </Text>
    </Stack>
  );

  if (message == null) {
    return content;
  }

  return (
    <Tooltip placement="right" content={message}>
      {content}
    </Tooltip>
  );
}

function formatPercent(value: number, precision: number): string {
  const percent = value * 100;
  const threshold = Math.pow(10, -precision);

  if (percent > 0 && percent < threshold) {
    return `<${threshold.toFixed(precision)}%`;
  }

  return `${percent.toFixed(precision)}%`;
}

function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value);
}
